import React from 'react';
import './TeamItem.css';

import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import { Link } from 'react-router-dom';



const TeamItem = ({ team }) => {

    // Destructuring props
    const { id, image, name, title, accounts } = team;

    return (

        <div className='team-item' key={id}>


            {/* Team member Picture */}
            <img src={image} alt={title} />

            <div className='team-content'>

                <div className='text'>

                    <Link
                        to={{
                            pathname: '/Team/' + name,
                        }}
                        state={team}>
                        <h3>{name}</h3> {/* Team member name */}
                    </Link>

                    <p>{title}</p> {/* Team member title */}

                    {/* Social media icons */}
                    <div className='icon-container'>
                        <a className='icon' href={accounts.facebook}><FaFacebookF /></a>
                        <a className='icon' href={accounts.linkedin}><FaLinkedin /></a>
                        <a className='icon' href={accounts.twitter}><FaXTwitter /></a>
                        <a className='icon' href={accounts.instagram}><FaInstagram /></a>
                    </div>

                </div>

            </div>

        </div>
    );
}

export default TeamItem;